<template>
  <div class="flex flex-col gap-4 md:grid md:grid-cols-3">
    <PromotionTrackingWrapper v-for="(banner, index) in banners" :key="index" :content="banner" class="">
      <SubBanner :content="banner" :small="small" />
    </PromotionTrackingWrapper>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useCampaignStore } from '~/stores';

type SubBanners = {
  fields: {
    subBanners: any[];
    smallBanners: boolean;
  };
};

type Props = {
  content?: SubBanners;
};

const props = withDefaults(defineProps<Props>(), {
  content: undefined,
});

const { campaigns, assortments } = storeToRefs(useCampaignStore());

const banners = computed(() => {
  let subBanners = (props.content as SubBanners)?.fields?.subBanners || [];

  // filter out campaigns that you cannot see
  if (
    subBanners.some(
      (banner) => banner.fields.linkUrl.includes('/kampanjer/') || banner.fields.linkUrl.includes('/sortiment/'),
    )
  ) {
    subBanners = subBanners.filter((banner) => {
      const isCampaignBanner =
        banner.fields.linkUrl.includes('/kampanjer/') || banner.fields.linkUrl.includes('/sortiment/');
      if (
        isCampaignBanner &&
        ![...campaigns.value, ...assortments.value].some((el) => banner.fields.linkUrl.endsWith(el.slug))
      ) {
        return false;
      }
      return true;
    });
  }

  return subBanners;
});
const small = ref((props.content as SubBanners)?.fields?.smallBanners || false);
</script>

<script lang="ts">
export default defineComponent({
  name: 'SubBanners',
});
</script>
